import { useEffect } from 'react';
import { TRIGGER_AGGREGATION_EVENT } from '../constants';

const useMoveAggregationContainers = (trigger: (ev) => void) => {
  useEffect(() => {
    document.addEventListener(TRIGGER_AGGREGATION_EVENT, trigger);

    return () => {
      document.removeEventListener(TRIGGER_AGGREGATION_EVENT, trigger);
    };
  }, []);
};

export const dispatchAggregationContainerMove = (newCoordinates: {
  leftContainerX: number;
  rightContainerX: number;
}) => {
  document.dispatchEvent(
    new CustomEvent(TRIGGER_AGGREGATION_EVENT, {
      detail: newCoordinates,
    }),
  );
};

export default useMoveAggregationContainers;
